import {booleanAttribute, Component, computed, inject, input} from '@angular/core';
import {EntityModel} from '../../../models/entity.model';
import {PackModel} from '../../../models/pack.model';
import {PromptModel} from '../../../models/prompt.model';
import {User, UserModel} from '../../../models/user.model';
import {RouterLink} from '@angular/router';
import {EntityListComponent} from '../entity-list/entity-list.component';
import {NgTemplateOutlet, TitleCasePipe} from '@angular/common';
import {IconComponent} from '../icon/icon.component';
import {NamedEntityModel} from "../../../models/named-entity.model";
import {IconType} from "../../icons";

@Component({
  selector: 'app-entity-card',
  imports: [
    RouterLink,
    NgTemplateOutlet,
    IconComponent,
    TitleCasePipe
  ],
  templateUrl: './entity-card.component.html',
  host: {
    class: 'app-block padded'
  },
  styleUrl: './entity-card.component.scss'
})
export class EntityCardComponent {
  readonly entity = input.required<NamedEntityModel<any>>()
  readonly linked = input<any, boolean>(false, { transform: booleanAttribute })
  readonly listControl = inject(EntityListComponent, {optional: true})

  protected isPromptOrPack(entity: EntityModel<any>): entity is PackModel | PromptModel {
    return entity instanceof PackModel || entity instanceof PromptModel
  }

  protected isUser(entity: EntityModel<any>): entity is UserModel {
    return entity instanceof UserModel
  }

  protected route(entity: EntityModel<any>) {
    return [
      entity instanceof PackModel ? '/packs' : '/prompts',
      entity.id
    ]
  }
}
